import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const CarStatusFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M19.9601 16.9498V11.1098L19.4801 10.1298H20.9201V8.52981H18.7201L17.0401 5.0498H6.96008L5.28008 8.52981H3.08008V10.1298H4.52008L4.04008 11.1098V16.9498C4.04008 18.0498 4.92008 18.9498 6.02008 18.9498C6.88008 18.9498 7.76008 18.4298 7.98008 17.3498H16.0201C16.2401 18.4298 17.1201 18.9498 17.9801 18.9498C19.0801 18.9498 19.9601 18.0498 19.9601 16.9498ZM11.324 9.01372L10.8181 8.00448L10.0838 8.86197L8.97168 10.1607H7.00006V11.6607H9.31684H9.66201L9.88652 11.3985L10.4889 10.6951L11.988 13.6859L12.5051 14.7175L13.2378 13.826L15.0178 11.6607H17.0001V10.1607H14.6634H14.3091L14.084 10.4345L12.8118 11.9821L11.324 9.01372Z"
      />
    </SvgIcon>
  );
});
